export default {
  name: 'LineScale',
  props: {
    value: {
      /**
       * проценты от 0 до 100
       */
      type: Number,
      default: 0
    },
    colorThumb: {
      type: String,
      default: 'grey' // red, yellow, green
    }
  }
}